import { default as React } from 'react'
import { default as MuiRating, RatingProps } from '@mui/material/Rating'

const Rating: React.FC<React.PropsWithChildren<RatingProps>> = (props) => {
  return <MuiRating {...props} />
}

export default Rating
